define('app/controllers/rebuts',['angular', 'app/services/shared'], function(angular) {
  var module = angular.module('app.rebuts', ['app.shared']);

  module.factory('rebutsService', ['$http', '$mdDialog', '$q', '$injector', '$location','sharedProperties', 'globalService', function ($http, $mdDialog, $q, $injector, $location, sharedProperties, globalService) {

    var serveis = {
      consumeAction: function(action, id, elem, routeParams) {
        var api_base_url = sharedProperties.getApiBaseUrl();
        var deferred = $q.defer();

        if (action.internalAction == 'generarRebuts') {
          var getMontYear = $mdDialog.prompt()
            .title('De quin mes vols generar els rebuts?')
            .textContent('Entra el mes i l\'any')
            .placeholder('MM/YYYY')
            .ariaLabel('Mes i any')
            //.initialValue('01/2016')
            //.targetEvent(event)
            .ok('Genera-ho!')
            .cancel('Ups... encara no!');
          $mdDialog.show(getMontYear).then(function(result){
            var re = new RegExp("([0-9]{1,2})/?([0-9]{4})");
            var res = re.exec(result);
            if (res == null) {
              var alert = $mdDialog.alert({
                title: 'Ups... I did it again!',
                textContent: 'El valor "' + result + '" es incorrecte, ha de tenir el format: MM/YYYY',
                ok: 'D\'acord'
              });

              $mdDialog.show( alert ).finally(function() {
                alert = undefined;
                action.active = true;
                deferred.resolve({ processed: true, elem: null, responses: null, error: null });
              });
            }
            else {
              $http.post(api_base_url + 'rebuts/generate/all', {Mes: parseInt(res[1]), Any: parseInt(res[2])}).then(function (response) {
                action.active = true;
                deferred.resolve({processed: true, elem: null, responses: null, error: null, refresh: true})
              }, function errorCallback(response) {
                action.active = true;
                deferred.reject(response);
              });
            }
          }, function() {
            action.active = true;
            deferred.resolve({processed: true, elem: null, responses: null, error: null, refresh: false})
          });
        }
        else {
          //console.log('continue to globalService');
          return globalService.consumeAction(action, id, elem, routeParams)
        }
        return deferred.promise;
      }
    };
    return serveis;
  }]);

  module.controller('RebutEditController', [
    '$scope',
    '$http',
    '$route',
    '$location',
    '$filter',
    'sharedProperties',
    '$mdEditDialog',
    '$mdDialog',
    'actionFactory',
    'consumer',
    'state',
    'info',
    'elem',
    'elems',
	'extrainfo',
    function($scope, $http, $route, $location, $filter, sharedProperties, $mdEditDialog, $mdDialog, actionFactory, consumer, state, info, elem, elems, extrainfo) {

      $scope.elemId = info.isInt ? parseInt($route.current.params.id):$route.current.params.id;
      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elem = elem;
      $scope.elems = elems;
	  $scope.extrainfo = extrainfo;
      actionFactory.complementActions(info, $scope.actions, $scope.elemId);

      $scope.query = {order:"Order"};

      $scope.editCarreg = function(carrec) {
        var CarregDlgController = ['$scope', '$mdDialog', function ($scope, $mdDialog) {

          $scope.elem = carrec;
          $scope.hide = function () {
            $mdDialog.hide()
          };
          $scope.cancel = function () {
            $mdDialog.cancel()
          };
          $scope.ok = function (value) {
            $mdDialog.hide(value)
          }
        }];

        $mdDialog.show({
          controller: CarregDlgController,
          templateUrl: 'templates/editCarrec.html',
          parent: angular.element(document.body),
          // targetEvent: event,
          clickOutsideToClose: true,
          fullscreen: false
        }).then(function (pagament) {

        }, function () {

        });
      };

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;

        if (action.name === 'AddCarrec') {
          var carrec = {RebutId:$scope.elem.Id, FincaId: $scope.elem.Arrendatari.FincaId, Order: 1, Data: new Date() };
          $scope.elem.Carrecs.push(carrec);
          $scope.editCarreg(carrec);
          return;
        }
        else if (action.name === 'EditCarrec') {
          $scope.editCarreg(action.row);
          return;
        }
        else if (action.name === 'DeleteCarrec') {
          var index = $scope.elem.Carrecs.indexOf(action.row);
          console.log("index", index);
          var confirm = $mdDialog.confirm()
            .title('Segur que vols eliminar aquest carrec?')
            .textContent('Si et rajas, no guardis els canvis d\'aquest rebut! ;-)')
            .ariaLabel('Bona sort!')
            //.targetEvent(event)
            .ok('Si, fes-ho!')
            .cancel('Potser millor deixar-ho!');
          $mdDialog.show(confirm).then(function() {
            $scope.elem.Carrecs.splice(index, 1);
          });
          return;
        }

        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.producte = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason);
        }, function (update) {
          console.log('Got notification', update);
        })
      });

    }
  ]);


  return module;
});

